export const normalizeTitle = title => {
  return title.split('_').join(' ')
}
